import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize Sentry and error handling
import { sentryService } from './services/sentry';
import { errorHandlerService } from './services/errorHandler';

// Initialize Sentry first
sentryService.init();

// Set up global error handling
errorHandlerService.setupGlobalErrorHandling();

declare global {
  interface Window {
    firebase: any;
    auth: any;
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const dropHandler = (e: Event) => {
  e.preventDefault();
  e.stopPropagation();
};

root.render(
  <div
    onDrop={dropHandler as any} onDragOver={dropHandler as any}  >
    <React.StrictMode>
      <App/>
    </React.StrictMode>
  </div>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or to analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
